.SectionWrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  padding: 4rem;
  width: 100%;
  max-width: 1200px;
}

@media (max-width: 1200px) {
  .SectionWrapper {
    padding: 4rem 2rem;
  }
}

@media (max-width: 768px) {
  .SectionWrapper {
    padding: 2rem 1rem;
  }
}
